import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_commonNextPage, fn_commonPrevPage} from "../../../../../function/FnPage";


@observer
class OrderMenuPagingBottomView extends Component {
    render() {

        const { rootStore } = this.props;
        const pageStore = rootStore.pageStore;

        return (
            <div className="paging paging_list">
                <button type="button" className="prev"
                        disabled={pageStore.getPagingInfo.page_no === 1 ? "disabled" : ""}
                        onClick={(event)=>fn_commonPrevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{pageStore.getPagingInfo.page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {pageStore.getPagingInfo.max_page}
                </p>
                <button type="button" className="next"
                        disabled={pageStore.getPagingInfo.page_no === pageStore.getPagingInfo.max_page ? "disabled" : ""}
                        onClick={(event)=>fn_commonNextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default OrderMenuPagingBottomView;